import { t } from '@lingui/core/macro';
import { SearchTextFieldAllowedPropertiesForTextFieldSearch } from 'shared/domains/apollo/generated/types';
/**
 * @returns Allowed values for search field modifier with name and description.
 */
export const allowedSearchFields = () => [
    {
        id: SearchTextFieldAllowedPropertiesForTextFieldSearch.AllApplicable,
        name: t({ message: 'Everything', comment: 'Universal search - search field: All applicable fields' }),
        description: t({
            message: 'Search in all applicable fields available',
            comment: 'Universal search - search field all applicable fields',
        }),
    },
    {
        id: SearchTextFieldAllowedPropertiesForTextFieldSearch.Name,
        name: t({ message: 'Title', comment: 'Universal search - search field: Title only' }),
        description: t({ message: 'Search in titles only', comment: 'Universal search - search field: Title only' }),
    },
    {
        id: SearchTextFieldAllowedPropertiesForTextFieldSearch.Body,
        name: t({ message: 'Content', comment: 'Universal search - search field: Content only' }),
        description: t({ message: 'Search in content only', comment: 'Universal search - search field: Content only' }),
    },
    {
        id: SearchTextFieldAllowedPropertiesForTextFieldSearch.MetadataDocumentNotes,
        name: t({ message: 'Notes', comment: 'Universal search - search field: Notes only' }),
        description: t({
            message: 'Search in document metadata notes only',
            comment: 'Universal search - search field: Notes only',
        }),
    },
];
